import complet from "../assets/services/lavage_complet.webp";
import exterieur from "../assets/services/lavage_exterieur.webp";
import interieur from "../assets/services/lavage_interieur.webp";
import lustrage_cirage from "../assets/services/lustrage_cirage.webp";
import nettoyage from "../assets/services/net.webp";
import caro from "../assets/services/traitement_caro.webp";

const service = [
    {
        id: 1,
        title: "Lavage complet",
        cover: complet,
        alt: "lavage complet de votre véhicule"
    }, {
        id: 2,
        title: "Lavage exterieur",
        cover: exterieur,
        alt: "lavage exterieur de votre véhicule"
    }, {
        id: 3,
        title: "Lavage interieur",
        cover: interieur,
        alt: "lavage interieur de votre véhicule"
    }, {
        id: 4,
        title: "Lustrage et cirage",
        cover: lustrage_cirage,
        alt: "lustrage et cirage de votre véhicule"
    }, {
        id: 5,
        title: "Nettoyage",
        cover: nettoyage,
        alt: "nettoyage de votre véhicule"
    }, {
        id: 6,
        title: "Traitement carrosserie",
        cover: caro,
        alt: "traitement carrosserie de votre véhicule"
    }
]
export default service;